import './index.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { useAppDispatch } from '@/store';
import { userLogin } from '@/store/auth/action';
import { getMenuList } from '@/store/menu-list/action';
import { ReactComponent as GlobalLine } from '@/assets/icons/global-line.svg';
import { ReactComponent as JayapranaLogo } from '@/assets/icons/jayaprana-logo.svg';
import { ReactComponent as LoginLogo } from '@/assets/icons/login-logo.svg';
import Button from '@/components/common/Button';
import Input from '@/components/common/Input';

const renderModalForm = ({ methods }, onSubmit, navigate) => (
	<div className="login__modal-form">
		<div className="login__modal-form__header">
			<p className="login__modal-form__header-title">Dashboard Login</p>
			<p className="login__modal-form__header-subtitle">Welcome back!</p>
		</div>
		<FormProvider {...methods}>
			<form
				className="login__modal-form__body"
				onSubmit={methods.handleSubmit(onSubmit)}
			>
				<div className="login__modal-form__body-input">
					<Input
						name="loginUsername"
						label="Username / E-mail"
						type="text"
						expanded
						placeholder="Enter username/e-mail"
						validationSchema={{ required: 'Please fill me', minLength: 10 }}
					/>
					<Input
						name="loginPassword"
						label="Password"
						type="password"
						placeholder="Enter password"
						expanded
					/>
					<Button
						type="button"
						variant="tertierry"
						className="px-0 py-0 ml-auto text-xs"
						onClick={() => navigate('/forgot-password')}
					>
						<p>Forgot Password?</p>
					</Button>
				</div>
				<div className="login__modal-form__body-remember">
					{/* TODO: INTO COMPONENT */}
					<input
						type="checkbox"
						id="loginRemember"
						{...methods.register('remember')}
					/>{' '}
					Remember Me
				</div>
				<div className="login__modal-form__body-cta">
					{/* TODO: check preflight overwriting button's bg-color to transparent - btn-primary passed from parent for now */}
					<Button type="submit" variant="primary" className="w-full">
						LOGIN
					</Button>
				</div>
			</form>
		</FormProvider>
	</div>
);

const renderModalRoute = () => (
	<div className="login__modal-route">
		<div className="login__modal-route__container">
			<div className="login__modal-route__header" />
			<p className="login__modal-route__title">Jayaprana Web</p>
			<p className="login__modal-route__subtitle">
				Make it easier for customers to book the field
			</p>
			<Button
				type="button"
				variant="tertierry"
				className="login__modal-route__cta"
			>
				<GlobalLine />
				<p>Go to Web</p>
			</Button>
		</div>
		<div className="login__modal-route__logo">
			<LoginLogo />
		</div>
	</div>
);

const Login = (): JSX.Element => {
	const methods = useForm();
	const navigate = useNavigate();
	const location = useLocation()
	const from = location.state?.from?.pathname || '/dashboard/home'

	const dispatch = useAppDispatch();

	const login = ({ email, password }) => new Promise((resolve) => {
		dispatch(userLogin({ email, password, cb: () => {
			dispatch(getMenuList({ cb: () => navigate(from, { replace: true }) }))
			} }))
		resolve({})
	})

	const onSubmit = async () => {
		const { loginUsername: email, loginPassword: password } =
			methods.getValues();
		try {
			await login({ email, password })
		} catch (e) {
			//TODO
		}
	};

	return (
		<div className="login">
			<div className="login__overlay" />
			<div className="login__container">
				<div className="login__logo text-white">
					<JayapranaLogo />
				</div>
				<div className="login__modal">
					{renderModalForm({ methods }, onSubmit, navigate)}
					{renderModalRoute()}
				</div>
			</div>
		</div>
	);
};

export default Login;
